var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.081,
    height: 195.194,
    viewBox: "0 0 237.081 195.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    transform: "translate(-88.833 -138.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8624",
    "data-name": "Group 8624",
    transform: "translate(135.252 199.024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4647",
    "data-name": "Rectangle 4647",
    width: 146.488,
    height: 93.816,
    transform: "translate(0 7.409)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4648",
    "data-name": "Rectangle 4648",
    width: 119.037,
    height: 73.038,
    transform: "translate(13.726 17.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4649",
    "data-name": "Rectangle 4649",
    width: 119.037,
    height: 4.485,
    transform: "translate(13.726 31.824)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4650",
    "data-name": "Rectangle 4650",
    width: 119.037,
    height: 4.485,
    transform: "translate(13.726 53.749)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4651",
    "data-name": "Rectangle 4651",
    width: 50.326,
    height: 4.485,
    transform: "translate(30.296 41.79)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4652",
    "data-name": "Rectangle 4652",
    width: 119.037,
    height: 4.485,
    transform: "translate(13.726 76.919)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4653",
    "data-name": "Rectangle 4653",
    width: 4.485,
    height: 61.862,
    transform: "translate(28.054 17.798)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4654",
    "data-name": "Rectangle 4654",
    width: 4.485,
    height: 38.442,
    transform: "translate(111.765 17.798)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4655",
    "data-name": "Rectangle 4655",
    width: 4.485,
    height: 73.038,
    transform: "translate(77.882 17.798)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4656",
    "data-name": "Rectangle 4656",
    width: 4.485,
    height: 36.34,
    transform: "translate(52.22 54.496)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2278",
    "data-name": "Ellipse 2278",
    cx: 3.096,
    cy: 3.096,
    rx: 3.096,
    ry: 3.096,
    transform: "translate(63.893 44.471)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10856",
    "data-name": "Path 10856",
    d: "M745.318,110.479a11.705,11.705,0,0,0-11.705,11.705c0,6.465,11.705,30.935,11.705,30.935s11.705-24.47,11.705-30.935A11.705,11.705,0,0,0,745.318,110.479Zm0,17.279a5.574,5.574,0,1,1,5.574-5.574A5.574,5.574,0,0,1,745.318,127.758Z",
    transform: "translate(-678.059 -110.479)",
    fill: "#555b70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8625",
    "data-name": "Group 8625",
    transform: "translate(249.186 152.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10889",
    "data-name": "Path 10889",
    d: "M0,0H76.729V94.292H0Z",
    transform: "translate(0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4658",
    "data-name": "Rectangle 4658",
    width: 15.688,
    height: 15.689,
    transform: "translate(5.154 8.276)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4659",
    "data-name": "Rectangle 4659",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 33.377)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4660",
    "data-name": "Rectangle 4660",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 40.045)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4661",
    "data-name": "Rectangle 4661",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 46.713)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4662",
    "data-name": "Rectangle 4662",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 53.38)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4663",
    "data-name": "Rectangle 4663",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 60.048)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4664",
    "data-name": "Rectangle 4664",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 66.715)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4665",
    "data-name": "Rectangle 4665",
    width: 55.694,
    height: 3.138,
    transform: "translate(12.998 73.383)",
    fill: "#555b70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8814",
    "data-name": "Group 8814",
    transform: "translate(88.833 138.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11121",
    "data-name": "Path 11121",
    d: "M0,3.316S4.249,15,6.77,11.473a6.388,6.388,0,0,0,.37-6.924L3.853,0Z",
    transform: "translate(4.288 87.412) rotate(3)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11122",
    "data-name": "Path 11122",
    d: "M290.581,389.864l-2.942,3.875s-.688,1.862,1.332,5.865,6.917-8.547,6.917-8.547Z",
    transform: "translate(-244.279 -296.531)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8813",
    "data-name": "Group 8813",
    transform: "translate(3.903 87.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11170",
    "data-name": "Path 11170",
    d: "M236.571,499.983l-7.488,1.043-4.68-74.057L208.49,498.94h-7.554s2.721-48.032,5.025-71.11,3.791-20.679,3.791-20.679h31.031l.971,21.367Z",
    transform: "translate(-200.196 -407.08)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11171",
    "data-name": "Path 11171",
    d: "M362.813,722.417l-5.519.5c-3.731-1.116-2.984-5.288-3.585-10.076l.84-6.717,1.175-.244c1.726-3.507,3.7-3.852,5.955-.476l.654-.12.84,5.458,2.3,7.757a3.06,3.06,0,0,1-2.656,3.916Z",
    transform: "translate(-353.709 -614.903)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11172",
    "data-name": "Path 11172",
    d: "M432.038,722.417l-5.519.5c-3.73-1.116-2.984-5.288-3.585-10.076l.84-6.717,1.175-.244c1.726-3.507,3.7-3.852,5.955-.476l.654-.12.84,5.458,2.3,7.757a3.06,3.06,0,0,1-2.657,3.916Z",
    transform: "translate(-394.853 -614.903)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8811",
    "data-name": "Group 8811",
    transform: "translate(54.277 27.79) rotate(155)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M0,20.268S.086,9.584,5.144,6.249c6.113-4.736,4.281-2.4,8.219-1.258,1.159.333,1.04-3.657,1.9-4.075,0,0,7.218-1.433,8.066-.713s1.049,8.806,1.049,8.806l-3.12,2-1.535,2.04L11.44,25.205Z",
    transform: "translate(5.029 0)",
    fill: "#fcb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M.021,14.1S-.261,9.581,1.246,7.98A8.751,8.751,0,0,1,5.011,5.817L16.681,9.2,24.07,0s2.959,7.065.416,11.84S17.453,17.556,13.1,17.388s-3.978-3.126-7.243-3.952A8.44,8.44,0,0,0,.021,14.1Z",
    transform: "translate(0 13.257)",
    fill: "#04304d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 1.941,
    cy: 4.411,
    rx: 1.941,
    ry: 4.411,
    transform: "translate(18.233 12.695)",
    fill: "#fdb7b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10880",
    "data-name": "Path 10880",
    d: "M59.366,331.861l-4.735-7.008L51.845,328.3l-8.631,3.21-4.5,2.689a127.4,127.4,0,0,1,4.5,21.555c1.368,11.777.22,24.288.976,25.554s29.527,1.114,30.865.233,0-3.659,0-3.659V354.607l1.763-9.756,4.217-11.535-14.939-7Z",
    transform: "translate(-30.857 -292.712)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10881",
    "data-name": "Path 10881",
    d: "M229.769,423.95l1.481-1.316a5.946,5.946,0,0,1,2.874,4.087c.4,2.771,4.664,23.728,5.146,27.313s-6.873,23.7-6.873,23.7l-4.981-2.336,3.835-21.364-6.1-16.1Z",
    transform: "translate(-181.071 -382.03)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10882",
    "data-name": "Path 10882",
    d: "M10.136,349.234H9.543s-7.729,23.25-7.729,28.716S6.1,399.226,6.1,399.226l4.628-2.909L8.985,379.361l2.821-7.875,3.908-6.465Z",
    transform: "translate(-1.814 -307.709)",
    fill: "#555b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10886",
    "data-name": "Path 10886",
    d: "M81.215,339.342l-6.729-4.75,6.729-5.542,2.906,1.31Z",
    transform: "translate(-45.977 -295.441)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10887",
    "data-name": "Path 10887",
    d: "M56.893,336.492l5.938-4.354-4.75-7.125-2.771,3.562Z",
    transform: "translate(-34.322 -292.988)",
    fill: "#d0cde1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImg);
export default __webpack_public_path__ + "static/media/homeImg.c4c24f2400bdbb1535d00c3734b1867c.svg";
export { ForwardRef as ReactComponent };